import packageJson from '../../package.json';
import { envVars } from './envVars';

const {
	REACT_APP_API_URL = '',
	REACT_APP_API_CERTIFICATE_URL = '',
	REACT_APP_LOGGER_DEBUG = '',
	REACT_APP_LOGGER_ERROR = '',
	REACT_APP_LOGGER_LOG = '',
	REACT_APP_BUILD_NUMBER = '',
	REACT_APP_COOKIES_DOMAIN = '',
	PUBLIC_URL = '',
	REACT_APP_ENVIRONMENT_RETURN_URL = '',
	REACT_APP_MAX_ELAPSED_EPOCH_MS = '',
	NODE_ENV = '',
	REACT_APP_MOCK_START = '',
} = process.env;

export const getValueOrDefault = (value: string, defaultValue: string): string => {
	return new RegExp('%%%\\w+%%%').test(value) ? defaultValue : value;
};

export const BaseConfig = {
	publicUrl: getValueOrDefault(envVars.base.publicUrl, PUBLIC_URL),
	environmentReturnUrl: getValueOrDefault(envVars.base.environmentReturnUrl, REACT_APP_ENVIRONMENT_RETURN_URL),
	environment: NODE_ENV as 'development' | 'production' | '',
	mockStart: REACT_APP_MOCK_START === 'true',
};

export const ApiConfig = {
	headers: {},
	url: getValueOrDefault(envVars.api.url, REACT_APP_API_URL),
	certificateUrl: getValueOrDefault(envVars.api.certificateUrl, REACT_APP_API_CERTIFICATE_URL),
};

export const LoggerConfig = {
	debug: getValueOrDefault(envVars.logger.debug, REACT_APP_LOGGER_DEBUG) === 'true',
	error: getValueOrDefault(envVars.logger.error, REACT_APP_LOGGER_ERROR) === 'true',
	log: getValueOrDefault(envVars.logger.log, REACT_APP_LOGGER_LOG) === 'true',
	buildNumber: getValueOrDefault(envVars.logger.buildNumber, REACT_APP_BUILD_NUMBER || packageJson.version),
};

export const CookiesConfig = {
	domain: getValueOrDefault(envVars.cookies.domain, REACT_APP_COOKIES_DOMAIN),
	privacyRules: 'PrivacyRules',
	remarketing: 'Remarketing',
	browserInfo: 'BrowserInfo',
};

export const MaxElapsedEpochMsConfig = getValueOrDefault(envVars.maxElapsedEpochMs, REACT_APP_MAX_ELAPSED_EPOCH_MS);
